import { axiosWithAuth } from "helpers";

export const applicationPaymentsService = {
	addPaymentMethod,
	getPaymentMethod,
};

const API_URL = process.env.REACT_APP_API_URL;

function addPaymentMethod({
	data,
	id,
}: {
	data: { [key: string]: any };
	id: string;
}) {
	return axiosWithAuth({
		method: "POST",
		data: data,
		url: `${API_URL}/api/applications/${id}/payment_methods`,
	});
}

function getPaymentMethod({
	applicationId,
	paymentMethodId,
}: {
	applicationId: string;
	paymentMethodId: number | string;
}) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/${applicationId}/payment_methods/${paymentMethodId}`,
	};

	return axiosWithAuth(options);
}
